import { useEffect } from "react";
import { activityLog } from "../model/activityLog";

/** Контекст экрана, который попадает в ctx каждого события, пока экран открыт. */
export const useActivityContext = (key: string, ctx: Record<string, unknown> | null): void => {
    const json = ctx ? JSON.stringify(ctx) : "";
    useEffect(() => {
        activityLog.setContext(key, json ? (JSON.parse(json) as Record<string, unknown>) : null);
        return () => activityLog.setContext(key, null);
    }, [key, json]);
};
